import { TextViewe6rp77b08kos as TextView } from './TextView.commonHtml.mjs';
import {
  HeaderSemantic_getInstance39z1p9hszg7wp as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
  get_H3Semantic2xvwj5aimpbn as get_H3Semantic,
  get_H4Semantic111wmmqwoslob as get_H4Semantic,
} from '../../models/Theme.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function h1(_this__u8e3s4, text) {
  // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.jba(view.ob6_1.ybe(HeaderSemantic_getInstance().ybe(get_H1Semantic())));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = view.tb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(text) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = text;
  }
  tmp.fbu(tmp_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function text(_this__u8e3s4, text) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = view.tb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(text) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = text;
  }
  tmp.fbu(tmp_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function h2(_this__u8e3s4, text) {
  // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.jba(view.ob6_1.ybe(HeaderSemantic_getInstance().ybe(get_H2Semantic())));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = view.tb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(text) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = text;
  }
  tmp.fbu(tmp_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function subtext(_this__u8e3s4, text) {
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.jba(view.ob6_1.ybe(SubtextSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = view.tb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(text) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = text;
  }
  tmp.fbu(tmp_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function h3(_this__u8e3s4, text) {
  // Inline function 'com.lightningkite.kiteui.views.direct.h3' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.jba(view.ob6_1.ybe(HeaderSemantic_getInstance().ybe(get_H3Semantic())));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = view.tb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(text) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = text;
  }
  tmp.fbu(tmp_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function h4(_this__u8e3s4, text) {
  // Inline function 'com.lightningkite.kiteui.views.direct.h4' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.jba(view.ob6_1.ybe(HeaderSemantic_getInstance().ybe(get_H4Semantic())));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = view.tb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(text) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = text;
  }
  tmp.fbu(tmp_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
//region block: exports
export {
  h1 as h13uhe3f4owggow,
  h2 as h22716j86ehrvde,
  h3 as h33vrlzi8yr34xu,
  h4 as h417senrl5p41re,
  subtext as subtext2z3zzf0nosi4q,
  text as text1v7b2bj2gx49v,
};
//endregion

//# sourceMappingURL=shortcuts.mjs.map
